import ProductStockWaitlist_API from './api/product-stock-waitlist';
import utilsService from './utils';

const exportedObject = {
  subscribe (id_profile, id_product) {
    return new Promise((resolve, reject) => {
      ProductStockWaitlist_API.create(id_profile, id_product).then(({data, notices}) => {
        utilsService.debugLog('Inscription waitlist produit : ', data, 'avertissements : ', notices);
        resolve([data, notices]);
      }).catch((error) => {
        reject(error);
      });
    });
  },
};

export default exportedObject;
